import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule, routingComponent } from './app-routing.module';
import { MaterialModule } from './material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { HeaderComponent } from './public/header/header.component';
import { HoverAnimation } from './public/masterdata/moushover';
import { HttpClientModule } from '@angular/common/http';
import { UserService } from './shared/services/user.service';
import { InstitutionComponent } from './public/institution/institution.component';
import { ProgramComponent } from './public/program/program.component';
import { BatchComponent } from './public/batch/batch.component';
import { CategoryTableComponent } from './private/tables/category-table/category-table.component';
import { SponserTableComponent } from './private/tables/sponser-table/sponser-table.component';
import { InstitutionTableComponent } from './private/tables/institution-table/institution-table.component';
import { ProgramTableComponent } from './private/tables/program-table/program-table.component';
import { GradeTableComponent } from './private/tables/grade-table/grade-table.component';
import { ModuleTableComponent } from './private/tables/module-table/module-table.component';
import { StudentsTableComponent } from './private/tables/students-table/students-table.component';
import { ApplicationTableComponent } from './private/tables/application-table/application-table.component';
import { BatchTableComponent } from './private/tables/batch-table/batch-table.component';
import { StudentsService } from './shared/services/students.service';
import { UserComponent } from './public/user/user.component';
import { UsermasterComponent } from './public/usermaster/usermaster.component';
import { CategoryComponent } from './public/category/category.component';
import { MAT_DATE_FORMATS } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

import { RoleTableComponent } from './private/tables/role-table/role-table.component';
import { NotificationComponent } from './private/widget/notification/notification.component';


import { ChartsModule } from 'ng2-charts';
import { CommonModule } from '@angular/common';
import { TransferHttpCacheModule } from '@nguniversal/common';
import { NgtUniversalModule } from '@ng-toolkit/universal';
import { MatDialogModule } from '@angular/material';
import { DrillingTableComponent } from './private/tables/drilling-table/drilling-table.component';




@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    CategoryComponent,
    routingComponent,
    HoverAnimation,
    ModuleTableComponent,
    CategoryTableComponent,
    InstitutionComponent,
    InstitutionTableComponent,
    ProgramComponent,
    ProgramTableComponent,
    SponserTableComponent,
    StudentsTableComponent,
    ApplicationTableComponent,
    BatchComponent,
    BatchTableComponent,
    GradeTableComponent,
    UserComponent,
    UsermasterComponent,
    RoleTableComponent,
    NotificationComponent,
    DrillingTableComponent,



  ],
  entryComponents: [NotificationComponent],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    MaterialModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    ReactiveFormsModule,
    ChartsModule,
    CommonModule,
    TransferHttpCacheModule,
    NgtUniversalModule,
    MatDialogModule,


  ],

  providers: [UserService, StudentsService,],
  bootstrap: [AppComponent]

})
export class AppModule { }


